import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "29",
  height: "28",
  viewBox: "0 0 29 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M5 12C5 12 7.00498 9.26822 8.63384 7.63824C10.2627 6.00827 12.5136 5 15 5C19.9706 5 24 9.02944 24 14C24 18.9706 19.9706 23 15 23C10.8969 23 7.43511 20.2543 6.35177 16.5M5 12V6M5 12H11",
      stroke: "#401D42",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }